import React from 'react'
import { capitalizeFirstLetter } from '../../../util'
import { Graphic } from '../Graphic'

export const DataSourceGraphic = ({ id, ...props }) => {
  const graphicName = 'Source' + capitalizeFirstLetter(id).replace(/ /g, '')

  return <Graphic name={graphicName} {...props} />
}
